// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__sSXUK","title":"AfterFrontImage_title__1118Q"};